class TabsBlock extends HTMLElement {
  connectedCallback() {
    // Build buttons from content panels
    this.buildTabButtons();
    
    this.buttons = this.querySelectorAll('.tab-button');
    this.contents = this.querySelectorAll('.tab-content');

    this.buttons.forEach((btn) => {
      btn.addEventListener('click', () => this.switchTab(btn));
    });

    // Activate first tab by default
    if (this.buttons.length > 0) this.switchTab(this.buttons[0]);
  }

  buildTabButtons() {
    const header = this.querySelector('.tabs__header');
    const panels = this.querySelectorAll('.tab-content');
    
    panels.forEach((panel) => {
      const button = document.createElement('button');
      button.className = 'tab-button';
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-controls', panel.id);
      button.dataset.tabTarget = panel.id;
      button.textContent = panel.dataset.tabTitle || 'Tab';
      
      header.appendChild(button);
    });
  }

  switchTab(activeButton) {
    // Deactivate all
    this.buttons.forEach((btn) => btn.setAttribute('aria-selected', 'false'));
    this.contents.forEach((panel) => panel.classList.remove('active'));

    // Activate current
    const targetId = activeButton.dataset.tabTarget;
    const targetPanel = this.querySelector(`#${targetId}`);

    activeButton.setAttribute('aria-selected', 'true');
    if (targetPanel) {
      targetPanel.classList.add('active');
    }
  }
}

if (!customElements.get('tabs-block')) {
  customElements.define('tabs-block', TabsBlock);
}